import Vue from 'vue';
import components from './config/components';
import '@/design-system';

/**
 * Initialize all form components globally, so they can be used everywhere.
 * This avoids certain erros as well. For example, circular dependencies when a form component tries
 * to import a wizard.
 */
Object.entries(components).forEach(([name, component]) => {
  Vue.component(name, component);
});
